import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {ModalRef} from "../../../shared-module/services/modal.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-password-reset-success-modal',
    imports: [
        ButtonComponent,
    ],
    templateUrl: './password-reset-success-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './password-reset-success-modal.component.scss'
})
export class PasswordResetSuccessModalComponent {
  readonly modalRef: ModalRef<PasswordResetSuccessModalComponent> = inject<ModalRef<PasswordResetSuccessModalComponent>>(ModalRef);
  readonly router: Router = inject(Router);

  public close() {
    this.modalRef.cancel();

    this.router.navigate(['/login']);
  }
}
